<template>
    <TipDialog @closeDialog="closeDialog" :tipinfo="tipinfo" :applycourse="applycourse"></TipDialog>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import TipDialog from './common/TipDialog';
    export default {
        name: 'authDialog',
        components: {
            TipDialog
        },
        data () {
            return {
                tipinfo: '网页版暂不提供认证流程，如需认证请到手机客户端进行认证。',
                applycourse: '58app-我的-我的求职-会员中心-个人认证-进行个人认证'
            }
        },
        created () {
            window.clickLog && window.clickLog(`from=pc-cvip-tbts-tanchuang-show-${this.cvipMes.cvipstate}`)
        },
        methods: {
            closeDialog () {
                window.clickLog && window.clickLog(`from=pc-cvip-tqtc-tbts-close-${this.cvipMes.cvipstate}`)
                this.$emit("closeDialog")
            }
        },
        computed: mapGetters({
            cvipMes: 'cvipMes',
            rightUsed: 'rightUsed' //4：黄金亮点 5：置顶 10：尊贵标识 11：个人认证 12：求职分析 13：免费刷新 14：求职保障 15：意外保险
        })
    }
</script>


// WEBPACK FOOTER //
// AuthDialog.vue?4605d69e